import api from '@/services/api';

export async function createCheckout({
  eventId,
  method,
  items,
  total,
  customerId,
  installments = 0,
}) {
  const { data } = await api.post(`/payments/checkout/${eventId}`, {
    method,
    items: items.map((item) => ({
      id: item.id,
      price: item.price,
      quantity: item.quantity,
    })),
    total,
    installments,
    customer_id: customerId,
  });

  return data;
}

export async function getRetryStatus() {
  const response = await api.get('/payments/retry-status');

  const payload = response.data?.data ?? response.data ?? {};

  return {
    has_pending: Boolean(payload.has_pending),
    has_permanently_failed: Boolean(payload.has_permanently_failed),
    has_pending_transfer: Boolean(payload.has_pending_transfer),
    total_pending_amount: Number(payload.total_pending_amount ?? 0),
    transfer_fee: Number(payload.transfer_fee ?? 0),
    net_amount: Number(payload.net_amount ?? 0),
    transfer_blocked_until: payload.transfer_blocked_until ?? null,
  };
}

export async function processRetryWithdrawals() {
  await api.post('/payments/retry-withdrawals');
}

export async function getEventBalanceSummary() {
  const { data } = await api.get('/users/finance/event-balance');
  return Array.isArray(data) ? data : [];
}

export async function createWithdrawalRequest(eventId, requestType) {
  const { data } = await api.post('/users/finance/withdrawal-requests', {
    event_id: eventId,
    request_type: requestType,
  });
  return data;
}

export async function earlyPixWithdrawal(eventId) {
  const { data } = await api.post('/users/finance/early-pix-withdrawal', {
    event_id: eventId,
  });
  return data;
}

export async function getFinanceAlerts() {
  const { data } = await api.get('/users/finance/alerts');
  return Array.isArray(data) ? data : [];
}

export async function reportWithdrawalToSupport(withdrawalRequestId) {
  const { data } = await api.post(`/users/finance/alerts/${withdrawalRequestId}/report-support`);
  return data;
}

export async function getFinanceSummary() {
  const { data } = await api.get('/users/finance/summary');
  return data ?? null;
}

export async function getLedgerEntries() {
  const { data } = await api.get('/users/finance/ledger');
  return Array.isArray(data) ? data : [];
}

export async function getWithdrawals() {
  const { data } = await api.get('/events/withdrawals/pending,processing,completed,failed,cancelled');
  return Array.isArray(data) ? data : [];
}

export async function getActiveBankDetails() {
  const { data } = await api.get('/users/finance/connected-accounts/stripe/active-bank-details');
  return data ?? {};
}

export async function getFinancePayments() {
  const { data } = await api.get('/users/finance/payments');
  return Array.isArray(data) ? data : [];
}

export async function getAccountReceiver() {
  const { data } = await api.get('/users/account-receiver');
  return data ?? null;
}
